import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoAlignLeft = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>AlignLeft</title>
    <path
      d="M12.09 16.986H27.21M6.858 8.842v16.286M12.09 25.128h9.293M12.09 8.842h8.11"
      stroke="currentColor"
      strokeWidth={2.036}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoAlignLeft;
